/*
Ashraf 01/20/2023 2698088984 added redux state for batches
Ashraf 01/25/2023 2698125110 Added reducer function for reject action
Dilip 03/o8/2023 2698197526 integrated undo batch api
Ravi 06/26/2023 2698088984 fixed submit issue
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpDelete, httpGet, httpPost} from '../../util/Rest';
import download from '../../util/DownloadLink';
import {submissionEnd} from './CommonActions/commonActions';

const initialData = {
  roleData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  userId: '',
  showDashboardWorkQueue: false,
  downloadSuccessMsg: null,
  batchData: [],
  batchHeaders: [],
  updateStatus: null,
  actionStatus: null,
};

const slice = createSlice({
  name: 'accountBatch',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getRoleData: (state, action) => {
      state.batchData = action?.payload?.batchData?.data;
      state.batchHeaders = action?.payload?.header;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAccountData: (state, action) => {
      state.successMsg = action?.payload?.response;
      state.updateStatus = action?.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getUserId: (state, action) => {
      state.userId = action.payload['userDetails'].userId;
    },
    approveBatch: (state, action) => {
      state.successMsg = action.payload?.response;
      state.actionStatus = action?.payload?.status;
    },
    postDownloadData: (state, action) => {
      state.isLoading = false;
      state.downloadSuccessMsg = 'Downloaded Successfully';
    },
    downloadResetMsg: (state, action) => {
      state.downloadSuccessMsg = null;
    },
    deleteBatch: (state, action) => {
      state.successMsg = action.payload?.message;
      state.actionStatus = action?.payload?.status;
    },
    undoBatch: (state, action) => {
      state.successMsg = action.payload?.response;
      state.actionStatus = action?.payload?.status;
    },

    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ?
        action.payload.data.error :
        action?.payload?.data?.message ?
          action?.payload?.data?.message :
          action.payload;
      state.isLoading = false;
    },
    resetBatchData: (state) => {
      state.batchData = [];
      state.batchHeaders = [];
    },
    resetMessageData: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = null;
      state.updateStatus = null;
      state.actionStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  getRoleData,
  fetchStart,
  postAccountData,
  resetMessageData,
  fetchError,
  approveBatch,
  resetBatchData,
  getUserId,
  postDownloadData,
  downloadResetMsg,
  undoBatch,
  deleteBatch,
} = slice.actions;
export const fetchBatchAccounts = (accountNumber, batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmbatch/find/account/batchName/${accountNumber}/${batchName}`)
      .then((data) => {
        if (data && data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getRoleData(data?.response));
          dispatch(getUserId(data.response));
        } else if (data.status === 500) {
          dispatch(fetchError(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postApprovedUrl = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`dmbatch/generateacknowledgementprinturl`, payload)
      .then((data) => {
        if (data && data?.status === 200) {
          dispatch(postDownloadData(payload));
          download(data.data);
        } else if (data && data?.data?.status === 500) {
          dispatch(fetchError(data?.data?.error));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postNewAccountDetails = (batchName, accountNumber, details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`dmbatch/update/dm/batch/${batchName}/${accountNumber}`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200 && data?.data?.status === 200) {
          dispatch(postAccountData(data));
        } else {
          dispatch(fetchError(data?.data?.error ? data?.data?.error : data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postApproveBatch = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmbatch/approve/dm/batchName/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(approveBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postRejectBatch = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmbatch/reject/dm/batchName/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(approveBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postDeleteBatch = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`dmbatch/delete/batch/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(deleteBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postUndoBatch = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmbatch/undo/dm/batchName/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(undoBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(resetBatchData());
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessageData());
  };
};

export const ResetDownloadMsg = () => {
  return (dispatch) => {
    dispatch(downloadResetMsg());
  };
};
